module.exports = __webpack_public_path__ + "static/img/talent-jacob.2df22b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/talent-jacob.png
// module id = xkSh
// module chunks = 0